module.exports = __webpack_public_path__ + "img/20231003.132570e0.jpg";